import type { QueryKey } from '@tanstack/react-query';
import { RISK_REPORT_DOC_INFO_KEY } from '../../../console/_tabs/riskTab/RiskReportCard/riskReportQueryKeys';

/**
 * Agent tools that change data the console has cached, and the query-key
 * prefixes to refresh once a turn that ran them finishes.
 *
 * The stream names a tool when it starts and says nothing about whether it
 * succeeded, so a turn where the tool was refused still refreshes. That costs
 * one refetch and shows the same data.
 */
const QUERIES_CHANGED_BY_TOOL: ReadonlyMap<string, readonly QueryKey[]> =
  new Map([
    // Builds the Cyber Risk Report synchronously, so the new report is
    // already there when the turn ends (OMNI-1165).
    ['generate_my_risk_report', [[RISK_REPORT_DOC_INFO_KEY]]],
  ]);

/** Query-key prefixes to invalidate after a turn that ran `toolNames`. */
export function queryKeysToRefreshAfterTurn(
  toolNames: readonly string[]
): QueryKey[] {
  return toolNames.flatMap((name) => QUERIES_CHANGED_BY_TOOL.get(name) ?? []);
}
